'use strict';

const jQuery = require('jquery');

export default ReportHistoryPlaceSelect;

const REPORT_HISTORY_PLACE_SELECT_COMPONENT_ATTR = 'data-report-history-place-select';
const REPORT_HISTORY_PLACE_SELECT_COMPONENT_SELECTOR = '[' + REPORT_HISTORY_PLACE_SELECT_COMPONENT_ATTR + ']';
const REPORT_HISTORY_PLACE_SELECT_PLACE = '[data-report-history-category-select-place]';
const REPORT_HISTORY_PLACE_SELECT_GENERATE = '[data-report-history-place-select-generate]';

class ReportHistoryPlaceSelect {

    constructor(element) {
        const component = this;

        component.element = jQuery(element);
        component.selectCategory = component.element.find(REPORT_HISTORY_PLACE_SELECT_PLACE);
        component.buttonGenerate = component.element.find(REPORT_HISTORY_PLACE_SELECT_GENERATE);

        component.buttonGenerate.prop('disabled', true);

        component.selectCategory.on('change', () => {
            component.buttonGenerate.prop('disabled', false);
        });
    }

}

jQuery(REPORT_HISTORY_PLACE_SELECT_COMPONENT_SELECTOR).each((index, element) => new ReportHistoryPlaceSelect(element));
